var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _CustomKitConfigurator_instances, emptyGroupState_fn, observeAddons_fn, readOptions_fn, normalizeOptions_fn, normalizeOption_fn, normalizeColorKey_fn, reportDataWarnings_fn, getGroup_fn, getOptionValue_fn, getPrice_fn, getAvailability_fn, isOutOfStock_fn, getColors_fn, getVisibleOptions_fn, render_fn, renderGroup_fn, renderOptionList_fn, renderSelected_fn, renderColors_fn, handleRootClick_fn, handleDocumentPointerDown_fn, handleDocumentKeyDown_fn, toggleMenu_fn, closeMenus_fn, selectColor_fn, selectOption_fn, emitChange_fn;
const GROUP_KEYS = ["frontShocks", "frontCoils", "rearShocks", "rearCoils"];
const VARIANT_ID_KEYS = {
  frontCoils: "frontCoilVariantId",
  frontShocks: "frontShockVariantId",
  rearCoils: "rearCoilVariantId",
  rearShocks: "rearShockVariantId"
};
const COMPONENT_LABELS = {
  frontCoils: "Front Coils",
  frontShocks: "Front Shocks",
  rearCoils: "Rear Coils",
  rearShocks: "Rear Shocks"
};
const OUT_OF_STOCK_PATTERN = /out of stock|sold out|unavailable|backorder|back-ordered|call for eta/i;
class CustomKitConfigurator extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _CustomKitConfigurator_instances);
  }
  connectedCallback() {
    if (this.dataset.initialized === "true") return;
    this.dataset.initialized = "true";
    this.selection = __privateMethod(this, _CustomKitConfigurator_instances, emptyGroupState_fn).call(this);
    this.colorSelection = __privateMethod(this, _CustomKitConfigurator_instances, emptyGroupState_fn).call(this);
    this.openKey = null;
    this.onRootClick = __privateMethod(this, _CustomKitConfigurator_instances, handleRootClick_fn).bind(this);
    this.onDocumentPointerDown = __privateMethod(this, _CustomKitConfigurator_instances, handleDocumentPointerDown_fn).bind(this);
    this.onDocumentKeyDown = __privateMethod(this, _CustomKitConfigurator_instances, handleDocumentKeyDown_fn).bind(this);
    this.addEventListener("click", this.onRootClick);
    document.addEventListener("pointerdown", this.onDocumentPointerDown);
    document.addEventListener("keydown", this.onDocumentKeyDown);
    this.setOptions(__privateMethod(this, _CustomKitConfigurator_instances, readOptions_fn).call(this));
    __privateMethod(this, _CustomKitConfigurator_instances, observeAddons_fn).call(this);
  }
  disconnectedCallback() {
    var _a;
    this.removeEventListener("click", this.onRootClick);
    document.removeEventListener("pointerdown", this.onDocumentPointerDown);
    document.removeEventListener("keydown", this.onDocumentKeyDown);
    (_a = this.addonsObserver) == null ? void 0 : _a.disconnect();
    this.addonsObserver = null;
    delete this.dataset.initialized;
  }
  setOptions(options = {}) {
    const normalized = __privateMethod(this, _CustomKitConfigurator_instances, normalizeOptions_fn).call(this, options);
    this.options = normalized.groups;
    this.meta = normalized.meta;
    this.selection = __privateMethod(this, _CustomKitConfigurator_instances, emptyGroupState_fn).call(this);
    this.colorSelection = __privateMethod(this, _CustomKitConfigurator_instances, emptyGroupState_fn).call(this);
    __privateMethod(this, _CustomKitConfigurator_instances, closeMenus_fn).call(this);
    __privateMethod(this, _CustomKitConfigurator_instances, reportDataWarnings_fn).call(this);
    __privateMethod(this, _CustomKitConfigurator_instances, render_fn).call(this);
  }
  getSelection() {
    return { ...this.selection };
  }
  getSelectedVariantIds() {
    return Object.fromEntries(
      GROUP_KEYS.map((key) => {
        var _a;
        return [VARIANT_ID_KEYS[key], ((_a = this.selection[key]) == null ? void 0 : _a.variantId) ?? null];
      })
    );
  }
  getCartItems(quantity = 1) {
    const itemQuantity = Math.max(1, Number(quantity) || 1);
    return GROUP_KEYS.flatMap((key) => {
      const option = this.selection[key];
      const variantId = option == null ? void 0 : option.variantId;
      return variantId ? [
        {
          id: variantId,
          quantity: itemQuantity,
          properties: {
            "_Custom Kit Component": COMPONENT_LABELS[key],
            "_Custom Kit Product": String(option.title || option.label || ""),
            "_Custom Kit Variant": String(option.variantTitle || "")
          }
        }
      ] : [];
    });
  }
  getSelectedTotalCents() {
    return GROUP_KEYS.reduce(
      (total, key) => {
        var _a;
        return total + (Number((_a = this.selection[key]) == null ? void 0 : _a.priceCents) || 0);
      },
      0
    );
  }
  validate() {
    return GROUP_KEYS.some((key) => {
      var _a;
      return Number((_a = this.selection[key]) == null ? void 0 : _a.variantId) > 0;
    });
  }
}
_CustomKitConfigurator_instances = new WeakSet();
emptyGroupState_fn = function() {
  return Object.fromEntries(GROUP_KEYS.map((key) => [key, null]));
};
observeAddons_fn = function() {
  const addons = this.querySelector("[data-custom-kit-addons]");
  if (!addons || typeof MutationObserver === "undefined") return;
  const refreshNavigation = () => {
    this.querySelectorAll("lift-kit-pdp-section-nav").forEach((navigation) => {
      if (typeof navigation.refresh === "function") navigation.refresh();
    });
  };
  this.addonsObserver = new MutationObserver(refreshNavigation);
  this.addonsObserver.observe(addons, {
    attributes: true,
    attributeFilter: ["class", "hidden"],
    subtree: true
  });
  window.requestAnimationFrame(refreshNavigation);
};
readOptions_fn = function() {
  const source = this.querySelector("[data-custom-kit-options]");
  try {
    return JSON.parse((source == null ? void 0 : source.textContent) || "{}");
  } catch (error) {
    console.warn("Custom Kit options JSON could not be parsed.", error);
    return {};
  }
};
normalizeOptions_fn = function(options) {
  const groups = Object.fromEntries(
    GROUP_KEYS.map((key) => [
      key,
      Array.isArray(options == null ? void 0 : options[key]) ? options[key].map((option) => __privateMethod(this, _CustomKitConfigurator_instances, normalizeOption_fn).call(this, option)) : []
    ])
  );
  return {
    groups,
    meta: (options == null ? void 0 : options._meta) && typeof options._meta === "object" ? options._meta : {}
  };
};
normalizeOption_fn = function(option = {}) {
  const rawColor = (option == null ? void 0 : option.color) || (Array.isArray(option == null ? void 0 : option.colors) ? option.colors[0] : null);
  const label = String((rawColor == null ? void 0 : rawColor.label) ?? (rawColor == null ? void 0 : rawColor.value) ?? "").trim();
  const key = __privateMethod(this, _CustomKitConfigurator_instances, normalizeColorKey_fn).call(this, (rawColor == null ? void 0 : rawColor.key) ?? (rawColor == null ? void 0 : rawColor.value) ?? label);
  return {
    ...option,
    color: label && key ? { ...rawColor, key, value: key, label } : null
  };
};
normalizeColorKey_fn = function(value) {
  return String(value ?? "").normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
};
reportDataWarnings_fn = function() {
  var _a;
  const warnings = Array.isArray((_a = this.meta) == null ? void 0 : _a.warnings) ? this.meta.warnings : [];
  warnings.forEach((warning) => console.warn("Custom Kit configuration warning:", warning));
  GROUP_KEYS.forEach((key) => {
    (this.options[key] || []).filter((option) => option == null ? void 0 : option.requiresVariantSelection).forEach((option) => {
      console.warn("Custom Kit product requires explicit variant selection and is disabled:", {
        group: key,
        productId: option.productId,
        title: option.title,
        variantCount: option.variantCount
      });
    });
  });
};
getGroup_fn = function(key) {
  return this.querySelector(`[data-custom-kit-group="${key}"]`);
};
getOptionValue_fn = function(option, index) {
  return String((option == null ? void 0 : option.value) ?? (option == null ? void 0 : option.id) ?? index);
};
getPrice_fn = function(option) {
  if (option == null ? void 0 : option.priceFormatted) return String(option.priceFormatted);
  if (option == null ? void 0 : option.formattedPrice) return String(option.formattedPrice);
  if (typeof (option == null ? void 0 : option.price) === "string") return option.price;
  return "";
};
getAvailability_fn = function(option) {
  if (option == null ? void 0 : option.availabilityText) return String(option.availabilityText);
  if ((option == null ? void 0 : option.available) === true) return "In Stock";
  if ((option == null ? void 0 : option.incoming) === true) return "Out of Stock (Available for Backorder)";
  return "Out of Stock";
};
isOutOfStock_fn = function(text) {
  return OUT_OF_STOCK_PATTERN.test(text || "");
};
getColors_fn = function(options, key) {
  const colors = /* @__PURE__ */ new Map();
  let hasUncoloredOptions = false;
  options.forEach((option) => {
    var _a, _b;
    if (((_a = option.color) == null ? void 0 : _a.key) && !colors.has(option.color.key)) {
      colors.set(option.color.key, option.color);
    } else if (!((_b = option.color) == null ? void 0 : _b.key)) {
      hasUncoloredOptions = true;
    }
  });
  if (colors.size > 0 && hasUncoloredOptions) {
    colors.set("__none__", {
      key: "__none__",
      value: "__none__",
      label: "Default"
    });
  }
  const preferredColor = (key == null ? void 0 : key.endsWith("Shocks")) ? "yellow" : "teal";
  const isPreferred = (color) => color.label.trim().toLowerCase() === preferredColor;
  return [...colors.values()].sort((a, b) => Number(isPreferred(b)) - Number(isPreferred(a)));
};
getVisibleOptions_fn = function(key) {
  const options = this.options[key] || [];
  const colors = __privateMethod(this, _CustomKitConfigurator_instances, getColors_fn).call(this, options, key);
  if (colors.length === 0) return options;
  const selectedColor = this.colorSelection[key];
  if (!selectedColor) return options;
  if (selectedColor === "__none__") {
    return options.filter((option) => {
      var _a;
      return !((_a = option.color) == null ? void 0 : _a.key);
    });
  }
  return options.filter((option) => {
    var _a;
    return ((_a = option.color) == null ? void 0 : _a.key) === selectedColor;
  });
};
render_fn = function() {
  GROUP_KEYS.forEach((key) => __privateMethod(this, _CustomKitConfigurator_instances, renderGroup_fn).call(this, key));
};
renderGroup_fn = function(key) {
  const group = __privateMethod(this, _CustomKitConfigurator_instances, getGroup_fn).call(this, key);
  const select = group == null ? void 0 : group.querySelector("[data-custom-kit-select]");
  const trigger = group == null ? void 0 : group.querySelector("[data-custom-kit-trigger]");
  if (!group || !select || !trigger) return;
  const options = this.options[key] || [];
  const colors = __privateMethod(this, _CustomKitConfigurator_instances, getColors_fn).call(this, options, key);
  const visibleOptions = __privateMethod(this, _CustomKitConfigurator_instances, getVisibleOptions_fn).call(this, key);
  const placeholder = "Select Option";
  select.replaceChildren(new Option(placeholder, ""));
  visibleOptions.forEach((option, index) => {
    const value = __privateMethod(this, _CustomKitConfigurator_instances, getOptionValue_fn).call(this, option, index);
    const label = (option == null ? void 0 : option.label) ?? (option == null ? void 0 : option.title) ?? value;
    const item = new Option(label, value);
    item.disabled = (option == null ? void 0 : option.selectable) === false;
    select.add(item);
  });
  const isDisabled = options.length === 0 || visibleOptions.length === 0;
  select.disabled = isDisabled;
  trigger.disabled = isDisabled;
  select.value = this.selection[key] ? __privateMethod(this, _CustomKitConfigurator_instances, getOptionValue_fn).call(this, this.selection[key], 0) : "";
  select.setAttribute("aria-invalid", "false");
  trigger.setAttribute("aria-invalid", "false");
  __privateMethod(this, _CustomKitConfigurator_instances, renderColors_fn).call(this, group, colors, key);
  __privateMethod(this, _CustomKitConfigurator_instances, renderOptionList_fn).call(this, group, visibleOptions, key);
  __privateMethod(this, _CustomKitConfigurator_instances, renderSelected_fn).call(this, group, this.selection[key], placeholder);
};
renderOptionList_fn = function(group, options, key) {
  const list = group.querySelector("[data-custom-kit-option-list]");
  if (!list) return;
  list.replaceChildren();
  options.forEach((option, index) => {
    const value = __privateMethod(this, _CustomKitConfigurator_instances, getOptionValue_fn).call(this, option, index);
    const title = String((option == null ? void 0 : option.label) ?? (option == null ? void 0 : option.title) ?? value);
    const description = String((option == null ? void 0 : option.description) ?? "");
    const availability = __privateMethod(this, _CustomKitConfigurator_instances, getAvailability_fn).call(this, option);
    const price = __privateMethod(this, _CustomKitConfigurator_instances, getPrice_fn).call(this, option);
    const button = document.createElement("button");
    button.type = "button";
    button.className = "flex min-h-[84px] w-full cursor-pointer items-center gap-3 rounded-[8px] px-2 py-2 text-left transition-colors hover:bg-[#f2f2f2] aria-selected:bg-[#f2f2f2] disabled:cursor-not-allowed disabled:opacity-50";
    button.dataset.customKitOption = value;
    button.dataset.groupKey = key;
    button.setAttribute("role", "option");
    button.setAttribute("aria-selected", String(this.selection[key] === option));
    button.disabled = (option == null ? void 0 : option.selectable) === false;
    const media = document.createElement("span");
    media.className = "flex h-14 w-14 shrink-0 items-center justify-center overflow-hidden rounded-full border-[0.61px] border-[#d9d9d9] bg-white";
    if (option == null ? void 0 : option.image) {
      const image = document.createElement("img");
      image.src = option.image;
      image.alt = "";
      image.width = 56;
      image.height = 56;
      image.loading = "lazy";
      image.className = "h-full w-full object-contain";
      media.append(image);
    }
    const copy = document.createElement("span");
    copy.className = "min-w-0 flex-1";
    const titleElement = document.createElement("span");
    titleElement.className = "block font-dinpro text-[14px] font-bold leading-[1.5] text-black";
    titleElement.textContent = title;
    copy.append(titleElement);
    if (description) {
      const descriptionElement = document.createElement("span");
      descriptionElement.className = "block font-inter text-[14px] font-normal leading-[1.5] text-black";
      descriptionElement.textContent = description;
      copy.append(descriptionElement);
    }
    const availabilityElement = document.createElement("span");
    availabilityElement.className = `mt-1 block font-dinpro text-[14px] font-bold leading-[1.5] ${__privateMethod(this, _CustomKitConfigurator_instances, isOutOfStock_fn).call(this, availability) ? "text-[#c80000]" : "text-[#1b844a]"}`;
    availabilityElement.textContent = availability;
    copy.append(availabilityElement);
    const priceElement = document.createElement("span");
    priceElement.className = "ml-1 shrink-0 self-center font-dinpro text-[14px] font-bold leading-[1.5] text-black";
    priceElement.textContent = price;
    button.append(media, copy, priceElement);
    list.append(button);
  });
};
renderSelected_fn = function(group, option, placeholderText = "Select Option") {
  const trigger = group.querySelector("[data-custom-kit-trigger]");
  const placeholder = group.querySelector("[data-custom-kit-placeholder]");
  const selected = group.querySelector("[data-custom-kit-selected]");
  const image = group.querySelector("[data-custom-kit-selected-image]");
  const title = group.querySelector("[data-custom-kit-selected-title]");
  const price = group.querySelector("[data-custom-kit-selected-price]");
  const availability = group.querySelector("[data-custom-kit-selected-availability]");
  if (!trigger || !placeholder || !selected) return;
  const hasSelection = Boolean(option);
  placeholder.textContent = placeholderText;
  placeholder.classList.toggle("hidden", hasSelection);
  selected.classList.toggle("hidden", !hasSelection);
  selected.classList.toggle("flex", hasSelection);
  trigger.classList.toggle("h-[74px]", !hasSelection);
  trigger.classList.toggle("min-h-[74px]", hasSelection);
  trigger.classList.toggle("py-6", hasSelection);
  trigger.classList.toggle("border-[#1654a3]", hasSelection);
  trigger.classList.toggle("bg-[#f5faff]", hasSelection);
  if (!option) {
    image == null ? void 0 : image.classList.add("hidden");
    return;
  }
  const availabilityText = __privateMethod(this, _CustomKitConfigurator_instances, getAvailability_fn).call(this, option);
  if (image) {
    image.classList.toggle("hidden", !option.image);
    image.src = option.image || "";
    image.alt = option.image ? String((option == null ? void 0 : option.title) ?? (option == null ? void 0 : option.label) ?? "") : "";
  }
  if (title) title.textContent = String((option == null ? void 0 : option.label) ?? (option == null ? void 0 : option.title) ?? "");
  if (price) price.textContent = __privateMethod(this, _CustomKitConfigurator_instances, getPrice_fn).call(this, option);
  if (availability) {
    const outOfStock = __privateMethod(this, _CustomKitConfigurator_instances, isOutOfStock_fn).call(this, availabilityText);
    availability.textContent = availabilityText;
    availability.classList.toggle("text-[#c80000]", outOfStock);
    availability.classList.toggle("text-[#1b844a]", !outOfStock);
  }
};
renderColors_fn = function(group, colors, key) {
  const container = group.querySelector("[data-custom-kit-colors]");
  const list = group.querySelector("[data-custom-kit-color-list]");
  const template = this.querySelector("[data-custom-kit-color-template]");
  if (!container || !list || !template) return;
  list.replaceChildren();
  container.classList.toggle("hidden", colors.length === 0);
  colors.forEach((color) => {
    const button = template.content.firstElementChild.cloneNode(true);
    const label = button.querySelector("[data-custom-kit-color-label]");
    const swatch = button.querySelector("[data-custom-kit-color-swatch]");
    const colorParts = color.key === "__none__" ? ["#d9d9d9"] : color.label.split("/").map((part) => part.trim()).filter(Boolean);
    const isSelected = this.colorSelection[key] === color.key;
    button.dataset.customKitColor = color.key;
    button.dataset.groupKey = key;
    button.setAttribute("aria-label", color.label);
    button.setAttribute("aria-pressed", String(isSelected));
    button.style.border = isSelected ? "1px solid #000000" : "0 solid transparent";
    if (swatch) {
      swatch.style.width = isSelected ? "28px" : "34px";
      swatch.style.height = isSelected ? "28px" : "34px";
    }
    if (label) label.textContent = color.label;
    colorParts.forEach((part) => {
      const segment = document.createElement("span");
      segment.className = "h-full flex-1";
      segment.style.backgroundColor = part;
      swatch == null ? void 0 : swatch.append(segment);
    });
    list.append(button);
  });
};
handleRootClick_fn = function(event) {
  const colorButton = event.target.closest("[data-custom-kit-color]");
  if (colorButton && this.contains(colorButton)) {
    __privateMethod(this, _CustomKitConfigurator_instances, selectColor_fn).call(this, colorButton.dataset.groupKey, colorButton.dataset.customKitColor);
    return;
  }
  const optionButton = event.target.closest("[data-custom-kit-option]");
  if (optionButton && this.contains(optionButton) && !optionButton.disabled) {
    __privateMethod(this, _CustomKitConfigurator_instances, selectOption_fn).call(this, optionButton.dataset.groupKey, optionButton.dataset.customKitOption);
    return;
  }
  const trigger = event.target.closest("[data-custom-kit-trigger]");
  if (!trigger || !this.contains(trigger) || trigger.disabled) return;
  const group = trigger.closest("[data-custom-kit-group]");
  __privateMethod(this, _CustomKitConfigurator_instances, toggleMenu_fn).call(this, group == null ? void 0 : group.dataset.customKitGroup);
};
handleDocumentPointerDown_fn = function(event) {
  if (!this.contains(event.target)) __privateMethod(this, _CustomKitConfigurator_instances, closeMenus_fn).call(this);
};
handleDocumentKeyDown_fn = function(event) {
  if (event.key === "Escape") __privateMethod(this, _CustomKitConfigurator_instances, closeMenus_fn).call(this, true);
};
toggleMenu_fn = function(key) {
  if (!key) return;
  const shouldOpen = this.openKey !== key;
  __privateMethod(this, _CustomKitConfigurator_instances, closeMenus_fn).call(this);
  if (!shouldOpen) return;
  const group = __privateMethod(this, _CustomKitConfigurator_instances, getGroup_fn).call(this, key);
  const menu = group == null ? void 0 : group.querySelector("[data-custom-kit-menu]");
  const trigger = group == null ? void 0 : group.querySelector("[data-custom-kit-trigger]");
  const arrow = group == null ? void 0 : group.querySelector("[data-custom-kit-arrow]");
  if (!menu || !trigger) return;
  this.openKey = key;
  menu.classList.remove("hidden");
  trigger.setAttribute("aria-expanded", "true");
  trigger.classList.add("border-[#1654a3]");
  arrow == null ? void 0 : arrow.classList.add("rotate-180");
};
closeMenus_fn = function(restoreFocus = false) {
  var _a, _b;
  const previousKey = this.openKey;
  this.querySelectorAll("[data-custom-kit-menu]").forEach((menu) => menu.classList.add("hidden"));
  this.querySelectorAll("[data-custom-kit-trigger]").forEach((trigger) => {
    var _a2;
    trigger.setAttribute("aria-expanded", "false");
    const group = trigger.closest("[data-custom-kit-group]");
    const hasSelection = Boolean((_a2 = this.selection) == null ? void 0 : _a2[group == null ? void 0 : group.dataset.customKitGroup]);
    trigger.classList.toggle("border-[#1654a3]", hasSelection);
  });
  this.querySelectorAll("[data-custom-kit-arrow]").forEach(
    (arrow) => arrow.classList.remove("rotate-180")
  );
  this.openKey = null;
  if (restoreFocus && previousKey) {
    (_b = (_a = __privateMethod(this, _CustomKitConfigurator_instances, getGroup_fn).call(this, previousKey)) == null ? void 0 : _a.querySelector("[data-custom-kit-trigger]")) == null ? void 0 : _b.focus();
  }
};
selectColor_fn = function(key, value) {
  var _a, _b, _c, _d;
  const color = __privateMethod(this, _CustomKitConfigurator_instances, getColors_fn).call(this, ((_a = this.options) == null ? void 0 : _a[key]) || [], key).find((item) => item.key === value);
  if (!key || !color) return;
  this.colorSelection[key] = value;
  if (((_c = (_b = this.selection[key]) == null ? void 0 : _b.color) == null ? void 0 : _c.key) !== value) this.selection[key] = null;
  __privateMethod(this, _CustomKitConfigurator_instances, closeMenus_fn).call(this);
  __privateMethod(this, _CustomKitConfigurator_instances, renderGroup_fn).call(this, key);
  const group = __privateMethod(this, _CustomKitConfigurator_instances, getGroup_fn).call(this, key);
  (_d = group == null ? void 0 : group.querySelector("[data-custom-kit-color-error]")) == null ? void 0 : _d.classList.add("hidden");
  this.validate();
  this.dispatchEvent(
    new CustomEvent("custom-kit:color-change", {
      bubbles: true,
      detail: { group: key, color }
    })
  );
  __privateMethod(this, _CustomKitConfigurator_instances, emitChange_fn).call(this);
};
selectOption_fn = function(key, value) {
  var _a, _b, _c;
  const group = __privateMethod(this, _CustomKitConfigurator_instances, getGroup_fn).call(this, key);
  const select = group == null ? void 0 : group.querySelector("[data-custom-kit-select]");
  const options = __privateMethod(this, _CustomKitConfigurator_instances, getVisibleOptions_fn).call(this, key);
  if (!group || !select) return;
  const selectedOption = options.find(
    (option, index) => __privateMethod(this, _CustomKitConfigurator_instances, getOptionValue_fn).call(this, option, index) === value && (option == null ? void 0 : option.selectable) !== false
  );
  if (!selectedOption) return;
  this.selection[key] = selectedOption;
  if ((_a = selectedOption.color) == null ? void 0 : _a.key) this.colorSelection[key] = selectedOption.color.key;
  select.value = value;
  group.querySelectorAll("[data-custom-kit-option]").forEach((button) => {
    button.setAttribute("aria-selected", String(button.dataset.customKitOption === value));
  });
  (_b = group.querySelector("[data-custom-kit-error]")) == null ? void 0 : _b.classList.add("hidden");
  select.setAttribute("aria-invalid", "false");
  (_c = group.querySelector("[data-custom-kit-trigger]")) == null ? void 0 : _c.setAttribute("aria-invalid", "false");
  __privateMethod(this, _CustomKitConfigurator_instances, closeMenus_fn).call(this);
  __privateMethod(this, _CustomKitConfigurator_instances, renderGroup_fn).call(this, key);
  __privateMethod(this, _CustomKitConfigurator_instances, renderSelected_fn).call(this, group, selectedOption);
  __privateMethod(this, _CustomKitConfigurator_instances, emitChange_fn).call(this);
};
emitChange_fn = function() {
  this.dispatchEvent(
    new CustomEvent("custom-kit:change", {
      bubbles: true,
      detail: {
        selection: this.getSelection(),
        variantIds: this.getSelectedVariantIds(),
        cartItems: this.getCartItems()
      }
    })
  );
};
if (!customElements.get("custom-kit-configurator")) {
  customElements.define("custom-kit-configurator", CustomKitConfigurator);
}
